import React, { FC, useEffect, useRef, useState } from 'react'
import { Modal, Row, Table, Input, Col, Tabs, Timeline, Button,Image, DatePicker, Select, TreeSelect } from 'antd'
import { ColumnsType, TablePaginationConfig } from 'antd/es/table'
import { assetsListModel } from '../assetsListModel'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, getBaseImgLookUrl } from '@/utils/constants'
import { transPgToPagination } from '@/model/globalModel'
import { assetsListService, IAssetsListDetail } from '../assetsListService'
import { ISearchPage } from '@/types/AppTypes'
import { ModeType } from '@/model/navModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'
import { FormItemTypeEnum, IYhFormBox, IYhFormItemsBox, IYhFormRef } from '@/components/YhFormBox/Types'
import { YhFormBox } from '@/components/YhFormBox'
import { ClockCircleOutlined, SmileOutlined, SyncOutlined } from '@ant-design/icons'
import { spawn } from 'child_process'
import { useDictModel } from '@/views/base/dict/dictModel'
import YhTootip from '@/components/YhTootip'
import { momentFormat } from '@/utils/utils'
import { YhBox } from '@/components/YhBox'
import moment from 'moment'
import { assetsMoveService } from '../../assetsMove/assetsMoveService'
import { useOrgModel } from '@/views/base/organization/orgModel'

const { Search } = Input

export const TransferLogModal = () => {
    const { getSelectedDictOne,getTreeNodeName } = useDictModel(() => []);
    const { transferLogVisible: visible, setTransferLogVisible, materialCodeRow,exportUser,resetSearchParam} = assetsListModel()
    const initPgCfg: TablePaginationConfig = { pageSize: 10, current: DEFAULT_FIRST_PAGE_NUM }
    const [dataSource, setDataSource] = useState<IAssetsListDetail[]>([])
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg)
    const formRef = useRef<IYhFormRef>()
    const [searchParam, setSearchParam] = useState<any>({})
    const { RangePicker } = DatePicker;
    const [departmentOutList, setDepartmentOutList] = useState<any>([]);   //用于搜索展示的数据
    const { getOrgTreeSelect } = useOrgModel()

    useEffect(() => {
        if (visible) {
            loadData()
            assetsMoveService.getDepartmentOutList({}).then(({retData})=>{
                if(retData.length>0){
                setDepartmentOutList(retData.filter((list)=>list).map((item)=>{
                    return{
                    label:item.departmentName,
                    value:item.department
                }}))}else{
                    setDepartmentOutList([])
                }
                })
        }
    }, [visible])

    useEffect(() => {
        if (searchParam) {
            loadData()
        }
    }, [searchParam])

    const columns: ColumnsType<any> = [
        {
            title: '序号',
            width: 60,
            align: 'center',
            fixed: 'left',
            render: (t, r, i) => i + 1,
        },
        {
            title: '物资编码',
            width: 160,
            dataIndex: 'materialCode',
        },
        {
            title: '物资名称',
            width: 160,
            dataIndex: 'materialName',
        },
        {
            title: '原始仓库',
            width: 160,
            dataIndex: 'originalWarehouseName',
            render: (text: string) => getTreeNodeName(text) ?? ''
        },
        {
            title: '原始货位',
            width: 130,
            dataIndex: 'originalShelfCode',
            render: (text: string) =><YhTootip text={text} />,      
        },
        {
            title: '转移仓库',
            width: 160,
            dataIndex: 'warehouseName',
            render: (text: string) => getTreeNodeName(text) ?? ''
        },
        {
            title: '转移货位',
            width: 160,
            dataIndex: 'shelfCode',
        },
        {
            title: '所属部门',
            width: 160,
            dataIndex: 'departmentName',
        },
        {
            title: '转移时间',
            width: 160,
            dataIndex: 'createTime',
            render: (text) => `${momentFormat(text)}`
        },
        {
            title: '转移人',
            width: 160,
            dataIndex: 'createUser',
        },
    ]


    const loadData = async (page: ISearchPage = initPgCfg) => {
        const searchParams = {
            ...searchParam,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
 
        }
        let { retData } = await assetsListService.transferLogPage(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
    }
    const rightChildren = (
        <div className="flex">
            {/* <Select
                size="small"
                allowClear
                showSearch
                optionFilterProp="label"
                className="border-r-8 ml-10"
                value={searchParam?.department}
                placeholder="所属部门"
                onChange={(e) =>
                     setSearchParam({ ...searchParam, department: e })
                    }
                options={departmentOutList}
            /> */}
            <TreeSelect
                // treeDefaultExpandAll
                allowClear
                placeholder="所属部门"
                treeData={getOrgTreeSelect(DictCodeEnmu.ORG)}
                showSearch
                treeNodeFilterProp='title'
                onChange={(e) =>
                    setSearchParam({ ...searchParam, department: e })
                   }
            />
                <Input
                size="small"
                allowClear
                datatype="round"
                className="border-r-8 ml-10"
                placeholder="请输入物资编码"
                value={searchParam?.materialCode}
                onChange={(e) => setSearchParam({ ...searchParam, materialCode: e.target.value })}
                onBlur={(e) => {
                    setSearchParam({ ...searchParam, materialCode: e.target.value?.trim() })
                }}
                onPressEnter={() => loadData(initPgCfg)}
            />
            <Input
                size="small"
                allowClear
                datatype="round"
                className="border-r-8 ml-10"
                placeholder="请输入物资名称"
                value={searchParam?.materialName}
                onChange={(e) => setSearchParam({ ...searchParam, materialName: e.target.value })}
                onBlur={(e) => {
                    setSearchParam({ ...searchParam, materialName: e.target.value?.trim() })
                }}
                onPressEnter={() => loadData(initPgCfg)}
            />

            <RangePicker
                style={{marginLeft:10,borderRadius:8}}
                size="small"
                allowClear
                className="ant-picker-round"
                format={"YYYY-MM-DD"}
                value={!searchParam?.startTime || !searchParam?.endTime ?
                    null :
                    [moment(searchParam?.startTime), moment(searchParam?.endTime)]}
                onChange={(value, timeStr) => {
                    console.log(timeStr);
                    debugger
                    let obj = {
                        startTime: timeStr[0] + ' 00:00:00'  ,
                        endTime: timeStr[1] + ' 23:59:59'  
                    }
                    setSearchParam({ ...searchParam, ...obj })
                }}
            />
            <Button style={{ margin: '2px 0 0px 15px' }} type="primary" size={'large'} onClick={() => loadData(initPgCfg)}>
                检索
            </Button>
        </div>
    )
    return (
        <Modal
            visible={visible}
            title="转移记录"
            onCancel={() => {
                setTransferLogVisible(false)
            }}
            footer={null}
            width={1200}
        >
        <YhBox title=" " rightChildren={rightChildren} style={{ marginBottom: '5px', paddingBottom: 0, padding: 0 }}>
             <Table
                rowKey={(record) => record.key}
                columns={columns}
                dataSource={dataSource}
                scroll={{ x: 'max-content' }}
                bordered
                pagination={{
                    ...pgCfg,
                    position: ['bottomRight'],
                    showTotal: () => `共${pgCfg.total}条`,
                    onChange: (pageNum, pageSize) => {
                        loadData({ pageNum, pageSize })
                    },
                    showSizeChanger: true
                }}
            />
        </YhBox>
        </Modal>
    )
}
